<script>
export default {
    name: "PrescriptionHistory",

    data() {

        return {
            patient: {},
            prescriptionHistory: [],
        };
    },

    mounted() {
        this.$root.loading = true;
        Promise.all([ this.fetchPatient(), this.fetchPrescriptions(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 200);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPatient() {

            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.query.patient}`;

            return this.$http.get(url).then(({ data }) => {
                this.patient = data.length ? data[0] : {};
            }).catch(() => {});
        },

        fetchPrescriptions() {
            let url = `Pharmacy/GetPatientDrugIssueHistory`;
                url += `?PrescriptionID=${this.$route.query.patientPrescriptionId}`;

            return this.$http.get(url).then(response => {
                this.prescriptionHistory = response.data;
                this.$root.loading = false;
            }).catch(() => { this.$root.loading = false; });
        },
    },
}
</script>
<template>
<div class="w-full flex flex-wrap items-center">
    <tail-address-header></tail-address-header>
    <div class="w-full flex flex-wrap content-start border-2 mb-2">
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">Name: {{ patient.names }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">IP File No: {{ patient.ipfileno || `-` }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">OP File No: {{ patient.opfileno || `-` }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">Gender: {{ patient.gender }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">DOB: {{ patient.dob | dateFormat }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm">MRN: {{ patient.patienT_ID }}</h5>
        </div>
        <div class="w-1/4 p-tiny">
          <h5 class="font-medium text-sm"> Visit No: {{ patient.visitNo }}</h5>
        </div>
    </div>
    <div class="w-full overflow-visible">
        <table class="table">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">Item</th>
                    <th class="p-tiny">Prescription</th>
                    <th class="p-tiny">Ordered</th>
                    <th class="p-tiny">Issued</th>
                    <th class="p-tiny">Date</th>
                    <th class="p-tiny">Username</th>
                    <th class="p-tiny">Memo</th>
                </tr>
            </thead>
            <tbody class="text-xs">
                <tr v-for="(prescription, idx) in prescriptionHistory" :key="idx">
                    <td class="p-tiny">{{ prescription.item }}</td>
                    <td class="p-tiny">{{ prescription.prescription || `-` }}</td>
                    <td class="p-tiny">{{ prescription.dosage || `-` }}</td>
                    <td class="p-tiny">{{ prescription.issued || `-` }}</td>
                    <td class="p-tiny">{{ prescription.date | dateFormat }}</td>
                    <td class="p-tiny">{{ prescription.user_Name }}</td>
                    <td class="p-tiny">{{ prescription.memo }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
</template>